export function isVisibleSegment(segment: string) {
  if (segment === '') {
    return false;
  }
  const invisiblePattern = /^(\s|\u200B|\u200C|\u200D|\uFEFF)+$/;
  return !invisiblePattern.test(segment);
}
